import React from 'react';
import Nailova from '../components/Nailova'; // adjust path as necessary

const NailovaPresentation = () => {
  return (
    <>
      <Nailova />
    </>
  );
};

export default NailovaPresentation;
